import React from 'react';
import { connect } from "react-redux";
import * as types from "../../../constants/actionTypes";
import GrantAdultProxyTerms from '../termsModalContent/grant/GrantAdultProxyTerms';
import AccessType from './AccessType';
import Terms from '../Terms';
import ProxyConfirmation from '../ProxyConfirmation';
import ConfirmationModal from "../../common/ConfirmationModal";
import OurStepManager from "../../common/OurStepManager";
import AccessorInfo from './AccessorInfo';
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import { RX, EPIC, GRANT, RXEPIC } from "../../../constants/textConstants";
import Spinner from "../../common/spinner";
import * as ProxyHelper from "../ProxyHelper";

//MAGIC STRINGS
const UNABLETOPROCESSMSG = "The request didn't go through.";

class GrantAccessProxyRequest extends React.Component {
    constructor(props) {
        super(props);
        /* for this release, the Pharmacy Card is to be shown as disabled*/
        this.initialState = {
            tooltipOpen: false,
            pharmacy: props.hasPharmacyLogin && props.hasMychartLogin ? false : props.hasPharmacyLogin ? true : false,
            healthrecord: (props.hasPharmacyLogin && props.hasMychartLogin) ? props.enableProxyGrantPharmacy ? false : true : props.hasMychartLogin ? true : false,
            isSubmitted: false,
            validationError: "",
            isTerms: false,
            showInfo: props.hasPharmacyLogin && props.hasMychartLogin ? false : props.hasPharmacyLogin || props.hasMychartLogin ? true : undefined,
            accessorName: "",
            email: "",
            confirmEmail: "",
            validaccessorsName: true,
            validEmail: true,
            validConfirmEmail: true,
            isValid: { email: false, confirmEmail: false },
            isConfirmedEmailMatching: false,
            validDob: true,
            isRetry: false,
       };
        this.state = this.initialState;
        this.submitNewProxyRequest = this.submitNewProxyRequest.bind(this);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.callback = this.callback.bind(this);
        this.grantAccessToSomeone = this.grantAccessToSomeone.bind(this);
        this.onGrantAccess = this.onGrantAccess.bind(this);
        this.onAccessTypeSelected = this.onAccessTypeSelected.bind(this);
        this.onChange = this.onChange.bind(this);
        this.dobInputId = "dobInput";
        this.onInputChange = this.onInputChange.bind(this);
        this.retryProxyRequest = this.retryProxyRequest.bind(this);
        this.getProxyTermsAndConditions = this.getProxyTermsAndConditions.bind(this);
        this.callbackOnLeave = this.callbackOnLeave.bind(this);
        this.navigateToProxyManagment = this.navigateToProxyManagment.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.GrantAccessProxyRequest.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    blockNavigation(nextLocation) {
        var returnValue = nextLocation && nextLocation.pathname === "/grantaccessProxy";
        return returnValue;
    }

    callbackOnLeave = (pathname) => {
        if (window.userToSwitch) {
            this.props.history.push("/proxymanagement");
        }
    }

    dataEntered() {
        const { healthrecord, pharmacy, accessorName, currentStep, email, confirmEmail } = this.state;
        const entered = currentStep > 0 || healthrecord || pharmacy || (accessorName && accessorName.trim() !== '') || (email && email.trim() !== '') || (confirmEmail && confirmEmail.trim() !== '') ? true : false;
        return entered;
    }

    retryProxyRequest(selectedOption) {
        logUI("MBHWeb.UI.GrantAccessProxyRequest.RetryGrantProxy", new Date(), Tools.getURLPath());
        if (this.state.showInfo)
            this.setState({ isSubmitted: false, isRetry: true, isTerms: false, stepManager: false });
        else {
            if (selectedOption === 'pharmacy') {
                this.setState({ isSubmitted: false, isRetry: true, isTerms: false, pharmacy: true, healthrecord: false, startAtStep: 0 });
            }
            else if (selectedOption === 'healthrecord') {
                this.setState({ isSubmitted: false, isRetry: true, isTerms: false, pharmacy: false, healthrecord: true, startAtStep: 0 });
            }
            else {
                this.setState({ isSubmitted: false, isRetry: true, isTerms: false, pharmacy: true, healthrecord: true, startAtStep: 0 });
            }
        }
    }
    onInputChange(field, value, valid) {
        const { isValid } = this.state;
        isValid[field] = valid;
        this.setState({ [field]: value, isValid, validationError: "" }, () => { this.isValid(); });
    }

    validateEmailInputs() {
        const { email, confirmEmail, isValid } = this.state;
        if (isValid.email && isValid.confirmEmail && email !== undefined && email !== null && confirmEmail !== undefined && confirmEmail !== null) {
            if (confirmEmail.toLowerCase() === email.toLowerCase() && confirmEmail.trim() !== "" && email.trim() !== "")
                return true;
            else
                return false;
        }
        return false;
    }

    isValid() {
        const { accessorName } = this.state;
        let validaccessorsName, validEmail, validConfirmEmail;

        validaccessorsName = accessorName && accessorName !== "" ? true : false;

        if (validaccessorsName !== this.state.validaccessorsName) {
            this.setState({
                validaccessorsName, validEmail, validConfirmEmail
            });
        }

        const bValid = this.validateEmailInputs();
        if (bValid) {
            this.setState({ isConfirmedEmailMatching: true });
        }
        else {
            this.setState({ isConfirmedEmailMatching: false });
        }
        return validaccessorsName && bValid;
    }

    grantAccessToSomeone() { //reset the state as we access the same page.  
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
        this.setState({ ...this.state, ...this.initialState, isValid: { email: false, confirmEmail: false } });
    }

    callback() {
        this.acceptProxyTermsAndConditions();
        this.submitNewProxyRequest();
    }

    submitNewProxyRequest() {
        const { accessorName, email, pharmacy, healthrecord } = this.state;
        const { userName, myChartId } = this.props;
        const proxySource = ProxyHelper.getProxySource(healthrecord, pharmacy);
        logUI(`MBHWeb.UI.GrantAccessProxyRequest.${ProxyHelper.getLogProxySource(proxySource)}.SubmitProxyGrantAccess`, new Date(), Tools.getURLPath());
        const requester = { myChartId, userName };
        if (healthrecord) {//only Epic
            this.props.grantEpicAccess(email, accessorName, requester, EPIC, GRANT);
        }
        if (pharmacy) { //only Rx
            this.props.grantRxAccess(email, accessorName, requester, RX, GRANT);
        }
        this.setState({ isSubmitted: true, validationError: "" });
    }

    getProxyTermsAndConditions() {
        const { getProxyTermsAndConditionsAction, useTermsV2Endpoint } = this.props;
        const { pharmacy, healthrecord } = this.state;
        const proxySource = ProxyHelper.getProxySource(healthrecord, pharmacy);
        // Get featureId
        const featureId = ProxyHelper.getFeatureId(GRANT, proxySource, null, "");
        // Check if already called getProxyTermsAndConditions
        const fetchedProxyTermsAndConditions = useTermsV2Endpoint ? featureId !== null && getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.response && getProxyTermsAndConditionsAction.response[0].featureId && getProxyTermsAndConditionsAction.response[0].featureId === featureId : featureId !== null && getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.response && getProxyTermsAndConditionsAction.response.featureId && getProxyTermsAndConditionsAction.response.featureId === featureId;
        // if not called getProxyTermsAndConditions, call getProxyTermsAndConditions
        if (!fetchedProxyTermsAndConditions && featureId) {
            logUI(`MBHWeb.UI.GrantAccessProxyRequest.${ProxyHelper.getLogProxySource(proxySource)}.GetProxyTermsAndConditions`, new Date(), Tools.getURLPath());
            this.props.getProxyTermsAndConditions(featureId);
        }
    }

    acceptProxyTermsAndConditions() {
        const { userName, myChartId, getProxyTermsAndConditionsAction, useTermsV2Endpoint } = this.props;
        const { pharmacy, healthrecord } = this.state;
        const proxySource = ProxyHelper.getProxySource(healthrecord, pharmacy);
        const featureId = ProxyHelper.getFeatureId(GRANT, proxySource, null, "");
        const versionId = useTermsV2Endpoint ? getProxyTermsAndConditionsAction.response[0].versionId : getProxyTermsAndConditionsAction.response.versionId;
        logUI(`MBHWeb.UI.GrantAccessProxyRequest.${ProxyHelper.getLogProxySource(proxySource)}.AcceptProxyTermsAndConditions`, new Date(), Tools.getURLPath());
        this.props.acceptProxyTermsAndConditions(featureId, true, userName, "", myChartId, "", versionId); // Save proxy terms and conditions flag
    }

    onGrantAccess() {
        if (this.isValid()) {
            this.setState({ isTerms: true });
            this.getProxyTermsAndConditions();
        } else {
            this.setState({ showAsInvalid: true, validationError: "Please enter the required information." });
        }
    }

    onChange(e) {
        if (e && e.target) {
            this.setState({ [e.target.name]: e.target.checked, validationError: "" });
        }
    }

    toggleTooltip() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    onAccessTypeSelected(failure) {
        if (!failure)
            this.setState({ showInfo: true });
        else

            this.setState({ showInfo: false });
    }

    onStepChange = (success, step) => {
        if (typeof window !== 'undefined' && success) {
            window.scrollTo(0, 0);
        }
        if (success) {
            this.setState({ currentStep: step });
        }
        if (this.activeInput) {
            this.activeInput.focus();
            this.activeInput = null;
        }
    }

    navigateToProxyManagment() {
        this.props.history.push("/proxymanagement");
    }

    render() {
        const { healthrecord, pharmacy, accessorName, isSubmitted, isTerms, email, confirmEmail, isValid, isConfirmedEmailMatching } = this.state;
        const { hasPharmacyLogin, hasMychartLogin, intiateProxyEpicGrant, intiateProxyRxGrant, getProxyTermsAndConditionsAction, enableProxyGrantPharmacy,
            errorMessageOnRx, errorMessageOnEpic, statusCode, useTermsV2Endpoint } = this.props;
        const accessorRequest = { "firstName": accessorName };
        const grantEpicErrorMessage = errorMessageOnEpic;
        const grantRxErrorMessage = errorMessageOnRx;
        const termsInfo = useTermsV2Endpoint ? getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.response && getProxyTermsAndConditionsAction.response[0].textToDisplay ? getProxyTermsAndConditionsAction.response[0].textToDisplay : "" : getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.response && getProxyTermsAndConditionsAction.response.textToDisplay ? getProxyTermsAndConditionsAction.response.textToDisplay : "";
        const modalContent = <GrantAdultProxyTerms toggle={this.toggleModal} termsandconditions={termsInfo} heading="Terms & Conditions" />;
        const showManageAccountAccess = statusCode && (statusCode === 429 || statusCode === 409 || statusCode === "AccountAccessExists");
        return (<div className="container-fluid body-content grant-access-proxy-container">
            {!isSubmitted ?
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        {!isTerms ?
                            <React.Fragment>
                                {hasPharmacyLogin && hasMychartLogin && !this.state.showInfo &&
                                    <OurStepManager backButtonCls='hidden' onStepChange={this.onStepChange} startingStep={this.state.startAtStep ? this.state.startAtStep : 0}>
                                        <AccessType
                                            isProgressBar
                                            steptitle='Access Type'
                                            onAccessTypeChange={this.onChange}
                                            healthrecord={healthrecord}
                                            pharmacy={pharmacy}
                                            enableProxyGrantPharmacy={enableProxyGrantPharmacy} />
                                        <AccessorInfo
                                            isConfirmedEmailMatching={isConfirmedEmailMatching}
                                            accessorName={accessorName}
                                            email={email}
                                            confirmEmail={confirmEmail}
                                            isValid={isValid}
                                            onInputChange={this.onInputChange}
                                            isProgressBar
                                            steptitle="Accessor's Info"
                                            healthrecord={healthrecord}
                                            pharmacy={pharmacy}
                                            getProxyTermsAndConditions={this.getProxyTermsAndConditions}
                                            onGrantAccess={this.onGrantAccess} />
                                        <Terms
                                            shouldHideContinueButton
                                            steptitle="Terms & Submit"
                                            links={[{ index: 0, headingText: "terms & conditions", modalComponent: modalContent }]}
                                            history={this.props.history}
                                            callback={this.callback}
                                            activityCode="MBHWeb.UI.ProxyGrant.AcceptTerms.Attestation"
                                            termsAndConditions={termsInfo}
                                            isWaitingForTermsInfo={getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.waiting} />
                                    </OurStepManager>
                                }
                                {(hasPharmacyLogin || hasMychartLogin) && ((this.state.isRetry && this.state.stepManager === false) || this.state.showInfo) &&
                                    <AccessorInfo
                                        isConfirmedEmailMatching={isConfirmedEmailMatching}
                                        accessorName={accessorName}
                                        email={email}
                                        confirmEmail={confirmEmail}
                                        isValid={isValid}
                                        onInputChange={this.onInputChange}
                                        isProgressBar={false}
                                        healthrecord={healthrecord}
                                        pharmacy={pharmacy}
                                        onGrantAccess={this.onGrantAccess}
                                        getProxyTermsAndConditions={this.getProxyTermsAndConditions} />
                                }
                            </React.Fragment>
                            :
                            <Terms
                                links={[{ index: 0, headingText: "terms & conditions", modalComponent: modalContent }]}
                                history={this.props.history}
                                callback={this.callback}
                                activityCode="MBHWeb.UI.ProxyGrant.AcceptTerms.Attestation"
                                termsAndConditions={termsInfo}
                                isWaitingForTermsInfo={getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.waiting} />
                        }
                    </div>
                </div>
                :
                <ProxyConfirmation
                    requestType={GRANT}
                    grantAccessToSomeone={this.grantAccessToSomeone}
                    accessToAnotherAccountPath="/grantaccessProxy"
                    proxyRequestData={accessorRequest}
                    grantEpicErrorMessage={grantEpicErrorMessage}
                    grantRxErrorMessage={grantRxErrorMessage}
                    grantEpicPending={intiateProxyEpicGrant && intiateProxyEpicGrant.waiting}
                    grantRxPending={intiateProxyRxGrant && intiateProxyRxGrant.waiting}
                    healthRecordSelected={healthrecord}
                    pharmacySelected={pharmacy}
                    retryFailedProxyRequest={this.retryProxyRequest}
                    hideRetry={showManageAccountAccess}
                    showManageAccountAccess={showManageAccountAccess}
                    navigateToManageAccount={this.navigateToProxyManagment}
                />
            }
            {
                !isSubmitted &&
                <ConfirmationModal when={this.dataEntered()} blockNavigation={this.blockNavigation.bind(this)} showModelInAllSteps callbackOnLeave={this.callbackOnLeave} />
            }
        </div>
        );
    }
}

const mapStateToProps = (state) => {
    const intiateProxyRxGrant = state.common[types.INITIATE_PROXY_RX_GRANT];
    const intiateProxyEpicGrant = state.common[types.INITIATE_PROXY_EPIC_GRANT];
    let errorMessageOnRx = null, errorMessageOnEpic = null, statusCode = null;

    const getErrorMsg = (error) => {
        const errorMsg = error.errorMessage && typeof error.errorMessage === "string"
            ? error.errorMessage
            : typeof error === "string"
                ? error
                : UNABLETOPROCESSMSG;

        return errorMsg;
    }

    // BSW Pharmacy Error
    if (intiateProxyRxGrant && intiateProxyRxGrant.error) {
        statusCode = intiateProxyRxGrant.error.errorCode
            ? intiateProxyRxGrant.error.errorCode
            : intiateProxyRxGrant.error.statusCode
                ? intiateProxyRxGrant.error.statusCode
                : typeof intiateProxyRxGrant.error === 'number' || intiateProxyRxGrant.error === "AccountAccessExists"
                    ? intiateProxyRxGrant.error
                    : null;

        if (intiateProxyRxGrant.errorMessage)
            errorMessageOnRx = getErrorMsg(intiateProxyRxGrant.errorMessage);
        else
            errorMessageOnRx = getErrorMsg(intiateProxyRxGrant.error);
    }

    // Medical Record Error
    if (intiateProxyEpicGrant && intiateProxyEpicGrant.error) {
        statusCode = intiateProxyEpicGrant.error.errorCode
            ? intiateProxyEpicGrant.error.errorCode
            : intiateProxyEpicGrant.error.statusCode
                ? intiateProxyEpicGrant.error.statusCode
                : typeof intiateProxyEpicGrant.error === 'number' || intiateProxyEpicGrant.error === "AccountAccessExists"
                    ? intiateProxyEpicGrant.error
                    : null;

        if (intiateProxyEpicGrant.errorMessage)
            errorMessageOnEpic = getErrorMsg(intiateProxyEpicGrant.errorMessage);
        else
            errorMessageOnEpic = getErrorMsg(intiateProxyEpicGrant.error);

        if (statusCode === null) {
            switch (errorMessageOnEpic) {
                case "This request has already been approved.":
                    statusCode = 409;
                    break;
                default:
                    break;
            }
        }
    }

    return {
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        hasMychartLogin: !state.common.epicEHRDown && state.domain.hm,
        token: state.domain.t,
        userName: state.domain.un,
        intiateProxyEpicGrant,
        intiateProxyRxGrant,
        getProxyTermsAndConditionsAction: state.common[types.PROXY_TERMS_AND_CONDITIONS],
        acceptProxyTermsAndConditionsAction: state.common[types.ACCEPT_PROXY_TERMS_AND_CONDITIONS],
        myChartId: state.domain.mc,
        enableProxyGrantPharmacy: state.session.serverData ? state.session.serverData.enableProxyGrantPharmacy : false,
        errorMessageOnRx,
        errorMessageOnEpic,
        statusCode,
        useTermsV2Endpoint: state.session.serverData ? state.session.serverData.useTermsV2Endpoint : false
    };
};

const mapDispatchToProps = (dispatch) => ({
    grantEpicAccess: (email, accessorName, requester, proxySource, requestType) =>
        dispatch({ type: types.INITIATE_PROXY_EPIC_GRANT, data: { attachments: [], proxySource, receiver: { email, firstName: accessorName }, requester, requestType } }),

    grantRxAccess: (email, accessorName, requester, proxySource, requestType) =>
        dispatch({ type: types.INITIATE_PROXY_RX_GRANT, data: { attachments: [], proxySource, receiver: { email, firstName: accessorName }, requester, requestType } }),

    getProxyTermsAndConditions: (featureId, callback) =>
        dispatch({ type: types.PROXY_TERMS_AND_CONDITIONS, data: { featureId }, callback }),

    acceptProxyTermsAndConditions: (featureId, isAccepted, userName, email, loginId, proxyId, versionId, callback) =>
        dispatch({ type: types.ACCEPT_PROXY_TERMS_AND_CONDITIONS, data: { featureId, isAccepted, userName, email, loginId, proxyId, versionId }, callback })
});

export default connect(mapStateToProps, mapDispatchToProps)(GrantAccessProxyRequest);